var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinus2 = function SvgMinus2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373635",
    fillRule: "evenodd",
    d: "M10.5 20a.5.5 0 0 1 .5-.5h18a.5.5 0 0 1 0 1H11a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })));
};
export default SvgMinus2;